module.exports = __webpack_public_path__ + "img/省级算力政策服务权威主渠道.856a11f4.png";